
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("JjYT4", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $0883b3e7b0cc22fd$export$bdfd709ae4826697, (v) => $0883b3e7b0cc22fd$export$bdfd709ae4826697 = v);
var $0883b3e7b0cc22fd$export$bdfd709ae4826697;
var $0883b3e7b0cc22fd$export$c9e73fbda7da57b6;
var $0883b3e7b0cc22fd$export$5a759dc7a1cfb72a;
"use strict";
var $0883b3e7b0cc22fd$var$bundleURL = {};
function $0883b3e7b0cc22fd$var$getBundleURLCached(id) {
    var value = $0883b3e7b0cc22fd$var$bundleURL[id];
    if (!value) {
        value = $0883b3e7b0cc22fd$var$getBundleURL();
        $0883b3e7b0cc22fd$var$bundleURL[id] = value;
    }
    return value;
}
function $0883b3e7b0cc22fd$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0883b3e7b0cc22fd$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $0883b3e7b0cc22fd$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0883b3e7b0cc22fd$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$0883b3e7b0cc22fd$export$bdfd709ae4826697 = $0883b3e7b0cc22fd$var$getBundleURLCached;
$0883b3e7b0cc22fd$export$c9e73fbda7da57b6 = $0883b3e7b0cc22fd$var$getBaseURL;
$0883b3e7b0cc22fd$export$5a759dc7a1cfb72a = $0883b3e7b0cc22fd$var$getOrigin;

});

var $f631002c8400eb38$exports = {};

$f631002c8400eb38$exports = (parcelRequire("JjYT4")).getBundleURL('cvtKm') + "hero-phone.9070f40d.jpg";


var $ea821938aba5d556$exports = {};

$ea821938aba5d556$exports = (parcelRequire("JjYT4")).getBundleURL('cvtKm') + "hero-mac.852ce857.jpg";


const $f386157b018f8ce0$var$fullImages = {
    phone: new URL($f631002c8400eb38$exports),
    mac: new URL($ea821938aba5d556$exports)
};
for (const [name, url] of Object.entries($f386157b018f8ce0$var$fullImages)){
    const image = document.querySelector(`.hero-image-${name}`);
    // Wait for the small placeholder so the full image doesn't compete for bandwidth.
    const upgrade = ()=>{
        const full = new Image();
        full.src = url;
        full.decode().then(()=>{
            image.src = full.src;
        }, ()=>{});
    };
    if (image.complete) upgrade();
    else image.addEventListener('load', upgrade, {
        once: true
    });
}


//# sourceMappingURL=index.0518f028.js.map
